import { connect } from 'react-redux';
import TimePicker from './TimePicker';
import { addDateToDraft } from '../../actions/draftAction';

const mapStateToProps = (state) => ({
  draft: state.draft,
});
const mapDispachToProps = (dispatch) => ({
  onDateChange: (date) => dispatch(addDateToDraft(date)),
});

export default connect(mapStateToProps, mapDispachToProps)(TimePicker);
